var map = {
	"./imgRecomendationSection.webp": "34f5",
	"./imgTextAndImageLeftSection.webp": "0d1d",
	"./imgTextAndImageRightSection.webp": "5bc7",
	"./imgTextAndImageRightSection2.webp": "d817",
	"./steelframing.webp": "f8ac",
	"./whatsapp.webp": "b333"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4ab";